import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { FINAL } from "@/data/content";
import { CTAPair } from "./CTAButtons";
import { MaskedLinesInView, Reveal } from "./Motion";

const FinalCTA = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "12%"]);

  return (
    <section ref={ref} id="contact" data-testid="final-cta-section" className="relative overflow-hidden">
      <motion.div style={{ y }} className="absolute inset-0 z-0 scale-110">
        <img src={FINAL.bg} alt="Cinematic wedding moment" className="w-full h-full object-cover" loading="lazy" />
      </motion.div>
      <div className="absolute inset-0 z-10 bg-gradient-to-b from-[#050505] via-[#050505]/85 to-[#050505]" />

      <div className="relative z-20 max-w-5xl mx-auto px-6 md:px-12 py-28 md:py-40 text-center flex flex-col items-center">
        <Reveal>
          <p className="text-xs tracking-[0.3em] uppercase text-gold mb-8">{FINAL.overline}</p>
        </Reveal>

        <h2 className="font-guj text-white font-semibold tracking-tight leading-[1.3] text-3xl sm:text-4xl lg:text-5xl max-w-3xl">
          <MaskedLinesInView lines={[FINAL.headingGuj]} />
        </h2>

        <Reveal delay={0.2}>
          <p className="mt-8 font-serif italic text-2xl md:text-3xl text-gold-gradient">
            {FINAL.headingEn}
          </p>
        </Reveal>

        <Reveal delay={0.3}>
          <div className="mt-12 flex justify-center">
            <CTAPair prefix="final" waLabel="Chat on WhatsApp" igLabel="Message on Instagram" />
          </div>
        </Reveal>

        <Reveal delay={0.4}>
          <p className="mt-8 text-xs tracking-[0.2em] uppercase text-white/40">
            No forms. No wait. Just message us.
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default FinalCTA;
